import React from "react";

const DescriptionModal = ({ show, text, position }) => {
    if (!show) return null;

    const style = {
        position: "absolute",
        top: "200px",
        left: "200px",
        backgroundColor: "#fff",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        zIndex: 1000,
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        whiteSpace: "pre-wrap", // handles multiline descriptions
        maxWidth: "300px"
    };

    return <div style={style}>{text}</div>;
};

export default DescriptionModal;
